<template>
  <div class="combobox-purchase-intem-display">
    <ComboboxPurchaseItemInfo :item="item" :unit-price="unitPrice" />
  </div>
</template>

<script setup lang="ts">
import ComboboxPurchaseItemInfo from "@/components/administration/combobox-display-templates/basic/ComboboxPurchaseItemInfo.vue"
import type { PurchaseItem } from "@/models/purchase-item.model"
import { Instruction } from "@/models/instruction.model"
import usePriceAgreements from "@/composables/administration/price-agreements"
import { computed, inject, type Ref } from "vue"

const props = defineProps<{
  item: PurchaseItem
}>()

const instruction = inject<Ref<Instruction> | undefined>("instruction", undefined)

const { unitPrice } = usePriceAgreements(
  computed(() => instruction?.value.project),
  props.item
)
</script>

<style scoped></style>
